document.addEventListener("DOMContentLoaded", () => {
  // MAGIC STRINGS
  const ACTIVE_FILTER_BTN = "enabled";
  const ACTIVE_FILTER_CLASS = "filters-active";

  //   FILTER DOM NODES
  const filterBtn = document.getElementById("filter-btn");
  const collectionFiltersContainer =
    document.getElementById("collection-filters");
  const filterForm = document.querySelector("#collection-filters form");
  const productList = document.getElementById("product-list");
  const hideFiltersBtn = document.getElementById("hide-filters-btn");
  const filterByBtns = document.querySelectorAll(".filter-by-btns");

  // MOBILE FILTER DOM NODES
  const mobileFilterContainer = document.querySelector(
    ".mobile-filter-container"
  );
  const mobileFilterFormContainer = document.querySelector(
    ".mobile-filter-form-container"
  );
  const mobileFilterForm = document.querySelector(
    ".mobile-filter-form-container form"
  );
  const mobileFilterBtn = document.getElementById("mobile-filter-btn");
  const mobileFilterByBtns = document.querySelectorAll(
    ".mobile-filter-by-btns"
  );
  const mobileClearFilterBtn = document.getElementById(
    "mobile-clear-filter-btn"
  );

  //   SORT DOM NOTES
  const sortFormContainer = document.querySelector('.sort-form-container');
  const sortBtn = document.getElementById("sort-btn");
  const sortForm = document.getElementById("sort-form");

  //   METHODS

  const showFilters = () => {
    filterBtn.classList.add(ACTIVE_FILTER_BTN);
    collectionFiltersContainer.classList.add(ACTIVE_FILTER_CLASS);
    collectionFiltersContainer.setAttribute("aria-hidden", false);
    filterBtn.innerText = "Clear Filters";
  };

  const hideFilters = () => {
    filterBtn.classList.remove(ACTIVE_FILTER_BTN);
    collectionFiltersContainer.classList.remove(ACTIVE_FILTER_CLASS);
    collectionFiltersContainer.setAttribute("aria-hidden", true);
    filterBtn.innerText = "Filters";
  };

  const clearAllFilterCheckboxes = () => {
    const filterCheckboxes = document.querySelectorAll(".filter-btn-checkbox");
    for (let i = 0; i < filterCheckboxes.length; i++) {
      filterCheckboxes[i].checked = false;
    }
  };

  const clearFilters = () => {
    let newUrl = `${window.location.pathname}`;
    // Update the browser URL without refreshing the page
    window.history.pushState({}, "", newUrl);

    fetch(`${newUrl}?section_id=main-collection`)
      .then((response) => response.text())
      .then((data) => {
        let parser = new DOMParser();
        let newDocument = parser.parseFromString(data, "text/html");
        let newProducts = newDocument.getElementById("product-list");
        productList.style.opacity = 1;

        clearAllFilterCheckboxes();

        if (newProducts) {
          document.getElementById("product-list").innerHTML =
            newProducts.innerHTML;
        }
      });
  };

  const showMobileFilterForm = () => {
    mobileFilterContainer.classList.add("active");
    mobileFilterBtn.setAttribute("aria-expanded", true);
  };

  const hideMobileFilterForm = () => {
    mobileFilterContainer.classList.remove("active");
    mobileFilterBtn.setAttribute("aria-expanded", false);
  };

  const mobileFilterButtonToggle = () => {
    const isMobileFilterFormActive =
      mobileFilterContainer?.classList?.contains("active");
    isMobileFilterFormActive ? hideMobileFilterForm() : showMobileFilterForm();
  };

  const filterButtonToggle = () => {
    if (filterBtn.classList.contains(ACTIVE_FILTER_BTN)) {
      clearFilters();
    } else {
      showFilters();
    }
  };

  const updateFilterState = (isMobile = false) => {
    let formData = new FormData(isMobile ? mobileFilterForm : filterForm);
    let searchParams = new URLSearchParams(formData).toString();
    console.log(searchParams);

    searchParams = searchParams.replace(
      "price_point=low",
      "filter.v.price.gte=0&filter.v.price.lte=50"
    );
    searchParams = searchParams.replace(
      "price_point=medium",
      "filter.v.price.gte=51&filter.v.price.lte=400"
    );
    searchParams = searchParams.replace(
      "price_point=high",
      "filter.v.price.gte=401&filter.v.price.lte=100000"
    );

    let newUrl = `${window.location.pathname}?${searchParams}`;

    // Update the browser URL without refreshing the page
    window.history.pushState({}, "", newUrl);

    productList.style.opacity = 0.5;

    fetch(`${newUrl}&section_id=main-collection`)
      .then((response) => response.text())
      .then((data) => {
        let parser = new DOMParser();
        let newDocument = parser.parseFromString(data, "text/html");
        let newProducts = newDocument.getElementById("product-list");
        productList.style.opacity = 1;

        if (newProducts) {
          scrollToTop();
          document.getElementById("product-list").innerHTML =
            newProducts.innerHTML;
        }
      });
  };

  const openFilterAccordions = ($e) => {
    const filterAccordionBtn = $e.target.closest(".filter-accordion-btn");

    if (filterAccordionBtn) {
      let filterType = filterAccordionBtn.dataset.filterType;
      let filterMatch;
      filterByBtns.forEach((filterBtn) => {
        if (filterBtn.dataset.filterId === filterType) {
          filterMatch = filterBtn;
        }
      });
      if (filterMatch) {
        if (filterMatch.classList.contains("filter-active")) {
          filterMatch.classList.remove("filter-active");
          filterMatch.setAttribute("aria-hidden", true);
          filterAccordionBtn.classList.remove("active-accordion");
          filterAccordionBtn.setAttribute("aria-expanded", false);
        } else {
          filterMatch.classList.add("filter-active");
          filterMatch.setAttribute("aria-hidden", false);
          filterAccordionBtn.classList.add("active-accordion");
          filterAccordionBtn.setAttribute("aria-expanded", true);
        }
      }

      const filterAccordions = document.querySelectorAll(".filter-accordion");

      filterAccordions.forEach((acc) => {
        if (acc.id !== filterType) {
          acc
            .querySelector(".filter-by-btns")
            .classList.remove("filter-active");
          acc
            .querySelector(".filter-by-btns")
            .setAttribute("aria-hidden", true);
          acc
            .querySelector(".filter-accordion-btn")
            .classList.remove("active-accordion");
          acc
            .querySelector(".filter-accordion-btn")
            .setAttribute("aria-expanded", false);
        }
      });
    }
  };

  const openMobileFilterAccordions = ($e) => {
    const filterAccordionBtn = $e.target.closest(".filter-accordion-btn");
    console.log(filterAccordionBtn);
    if (filterAccordionBtn) {
      let filterType = filterAccordionBtn.dataset.filterType;
      let filterMatch;
      mobileFilterByBtns.forEach((filterBtn) => {
        if (filterBtn.dataset.filterId === filterType) {
          filterMatch = filterBtn;
        }
      });
      if (filterMatch) {
        if (filterMatch.classList.contains("filter-active")) {
          filterMatch.classList.remove("filter-active");
          filterMatch.setAttribute("aria-hidden", true);
          filterAccordionBtn.classList.remove("active-accordion");
          filterAccordionBtn.setAttribute("aria-expanded", false);
        } else {
          filterMatch.classList.add("filter-active");
          filterMatch.setAttribute("aria-hidden", false);
          filterAccordionBtn.classList.add("active-accordion");
          filterAccordionBtn.setAttribute("aria-expanded", true);
        }
      }
      const filterAccordions = document.querySelectorAll(
        ".mobile-filter-accordion"
      );

      filterAccordions.forEach((acc) => {
        if (acc.id !== filterType) {
          acc
            .querySelector(".mobile-filter-by-btns")
            .classList.remove("filter-active");
          acc
            .querySelector(".mobile-filter-by-btns")
            .setAttribute("aria-hidden", true);
          acc
            .querySelector(".filter-accordion-btn")
            .classList.remove("active-accordion");
          acc
            .querySelector(".filter-accordion-btn")
            .setAttribute("aria-expanded", false);
        }
      });
    }
  };

  const setFilterStateOnLoad = () => {
    const filterCheckboxes = document.querySelectorAll(".filter-btn-checkbox");
    const params = new URLSearchParams(window.location.search);
    const queryArray = [...params.entries()]; // all key-value pairs
    console.log(queryArray);
    if (queryArray?.length) {
      for (let filterCheckbox of filterCheckboxes) {
        for (let param of params) {
          const key = param[0];
          const value = param[1];
          if (key === "filter.v.price.gte" && value === "0") {
            document
              .getElementById("filter-low-price")
              .setAttribute("checked", true);
          }
          if (key === "filter.v.price.gte" && value === "51") {
            document
              .getElementById("filter-medium-price")
              .setAttribute("checked", true);
          }
          if (key === "filter.v.price.gte" && value === "401") {
            document
              .getElementById("filter-high-price")
              .setAttribute("checked", true);
          }
          if (filterCheckbox.name === key && filterCheckbox.value === value) {
            filterCheckbox.setAttribute("checked", true);
          }
        }
      }
    }
  };

  setFilterStateOnLoad();

  // MOBILE EVENT LISTENERS
  if (mobileFilterBtn)
    mobileFilterBtn.addEventListener("click", mobileFilterButtonToggle);
  mobileFilterFormContainer.addEventListener(
    "click",
    openMobileFilterAccordions
  );
  mobileFilterForm.addEventListener("change", () => updateFilterState(true));
  mobileClearFilterBtn.addEventListener("click", clearFilters);
  // END MOBILE EVENT LISTENERS
  filterBtn.addEventListener("click", filterButtonToggle);
  filterForm.addEventListener("change", () => updateFilterState(false));
  hideFiltersBtn.addEventListener("click", hideFilters);
  filterForm.addEventListener("click", openFilterAccordions);

  const toggleSortForm = () => {
    sortForm.classList.toggle("sort-form-active");
    const sortFormActive = sortForm.classList.contains("sort-form-active");
    sortForm.setAttribute("aria-hidden", !sortFormActive);
    sortBtn.setAttribute("aria-expanded", sortFormActive);
    sortBtn.classList.toggle("sort-expanded");
    sortFormContainer.classList.toggle('sort-container-blue');
  };

  const updateSortState = ($e) => {
    console.log($e.target.value);
    const params = new URLSearchParams(window.location.search);

    params.set("sort_by", $e.target.value); // Update sorting parameter

    const newUrl = `${window.location.pathname}?${params.toString()}`;

    window.history.pushState({}, "", newUrl); // Update URL without reloading

    productList.style.opacity = 0.5;

    fetch(`${newUrl}&section_id=main-collection`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(data, "text/html");
        const newProducts = newDocument.getElementById("product-list"); // Your product container ID
        productList.style.opacity = 1;
        if (newProducts) {
          scrollToTop();
          document.getElementById("product-list").innerHTML =
            newProducts.innerHTML;
        }
      });
  };

  sortBtn.addEventListener("click", toggleSortForm);
  sortForm.addEventListener("change", updateSortState);
});
